module.exports = __webpack_public_path__ + "static/img/3883_phase_function_Paper_Points.8767480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3883_phase_function_Paper_Points.png
// module id = BTyc
// module chunks = 0